import React, { useMemo, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import {
  Container,
  Box,
  Divider,
  CardContent,
  Button,
  Typography,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
} from '@material-ui/core';
import LogoExtended from '../../assets/extendedLogo.svg';
import MainLogos from '../../assets/main-logos.svg';
import ShowSnackbar, { SetSnackbarType } from '../../components/SnackBar';
import api from '../../services/api';
import { optionStyles } from './styles';
import {
  DriverIncidenteDetailsType,
  Victim,
  Vehicle,
} from '../../@types/SinisterFormTypes';
import { jsonb as JsonbType } from '../../@types/jsonb';
import { RecordsResponseType } from '../../@types/records';

const BulletinAcess: React.FC = () => {
  const [err, setErr] = useState<boolean>(false);
  const [sinisterCode, setSinisterCode] = useState<string>('');
  const [carPlate, setCarPlate] = useState<string>('');
  const history = useHistory();
  const [snackBar, setSnackbar] = useState<SetSnackbarType>({ open: false, message: '' });
  const classes = optionStyles();
  const formRef = useRef<FormHandles>(null);

  const Jsonb: JsonbType = {
    jsonb: {
      driverVeiculo: {
        'Tipo Veículo': {
          _rule_type: 'containment_multiple',
          contains: [],
        },
        Placa: {
          _rule_type: 'containment_multiple',
          contains: [carPlate],
        },
      },
      driverVitima: {
        'Gravidade da Lesão': {
          _rule_type: 'containment_multiple',
          contains: [],
        },
      },
      driverIncidenteDetails: {
        Natureza: {
          _rule_type: 'containment',
          contains: [],
        },
        Severidade: {
          _rule_type: 'containment',
          contains: [],
        },
        'Código do Acidente': {
          _rule_type: 'containment',
          contains: [sinisterCode],
        },
      },
    },
  };
  const authHeader = useMemo(() => {
    return { Authorization: `Token ${process.env.REACT_APP_HIGH_CLASS_AUTH_TOKKEN}` };
  }, []);

  const handleSubmit = async () => {
    const { data } = await api.get<RecordsResponseType>('api/incident_records/', {
      headers: authHeader,
      params: { ...Jsonb },
    });
    // .then((response)=>{
    //   console.log("response.log",response.data.results);

    // })
    //   .catch((error) => {
    //     console.log("erro ao enviar",error);
    //     setSnackbar({
    //       open: true,
    //       message: 'Código do acidente ou placa do veículo incorretos!',
    //     });
    //   setErr(true);

    // });
    if (data.results[0]) {
      history.push(`/acessarboletim/${data.results[0].uuid}`);
    } else {
      setSnackbar({
        open: true,
        message: 'Código do acidente ou placa do veículo incorretos!',
      });
      setErr(true);
    }
  };

  const handleSinisterCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSinisterCode(event.target.value);
  };

  const handleCarPlateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCarPlate(event.target.value);
  };
  return (
    <Container maxWidth="xl" className={classes.rootContainer}>
      <Box className={classes.rootCard}>
        <CardContent className={classes.cardContent}>
          <img src={LogoExtended} alt="Logo VIDA" width="200" className={classes.logo} />
          <Divider className={classes.divider} orientation="horizontal" />
          <Typography variant="h6" style={{ color: '#404040', marginBottom: '5%' }}>
            Acessar boletim de ocorrência
          </Typography>

          <Form className={classes.rootForm} ref={formRef} onSubmit={handleSubmit}>
            {err && (
              <Typography
                variant="subtitle2"
                style={{ color: '#90002B', marginBottom: '5%' }}
              >
                Código do sinistro ou placa do veículo incorretos. Tente novamente
              </Typography>
            )}
            <FormControl variant="outlined">
              <InputLabel htmlFor="username">Código do sinistro</InputLabel>
              <OutlinedInput
                id="sinisterCode"
                name="sinisterCode"
                label="Código do sinistro"
                type="text"
                required
                placeholder="Código do sinistro"
                className={classes.input}
                value={sinisterCode}
                onChange={handleSinisterCodeChange}
              />
            </FormControl>
            <FormControl variant="outlined">
              <InputLabel htmlFor="password"> Placa do Veículo</InputLabel>
              <OutlinedInput
                id="password"
                name="password"
                label="Placa do Veículo"
                type={'text'}
                required
                placeholder="Insira a placa do veículo"
                className={classes.input}
                value={carPlate}
                onChange={handleCarPlateChange}
                endAdornment={<InputAdornment position="end"></InputAdornment>}
              />
            </FormControl>
            <Button
              variant="outlined"
              className={classes.rootButton}
              onClick={() => handleSubmit()}
            >
              Acessar
            </Button>
            {/* <a
                        href={`/acessarboletim/5baf497c-b146-4aff-afd4-2a94e94923f1`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'none', color: 'black' }}
                      >
            <Button
              variant="outlined"
              className={classes.rootButton}
            >
              Acessar
            </Button>
            </a> */}
          </Form>
        </CardContent>
        <img src={MainLogos} alt="Logo VIDA" className={classes.mainLogos} />
      </Box>

      <ShowSnackbar
        open={snackBar.open}
        message={snackBar.message}
        setSnackbar={setSnackbar}
      />
    </Container>
  );
};

export default BulletinAcess;
